import { IoSchoolOutline } from "react-icons/io5";
import { FaRegFileAlt } from "react-icons/fa"; // New icon for unit plans

export const SidebarData = [
  {
    title: "Students",
    path: "/students",
    icon: <IoSchoolOutline />,
    accessLevel: 0,
  },
  {
    title: "Personalised Plans",
    path: "/unitPlans",
    icon: <FaRegFileAlt />,
    accessLevel: 0,
  },
];
